const _ = require("lodash");
const { getObjectValue, isEquivalent, paramString } = require("@root/helpers");

module.exports = {
	setTeamPropertyValue({ commit, rootState, rootGetters }, payload) {
		let teamId = rootGetters.currentTeam.id;

		return axios.patch(`/api/teams/${teamId}`, payload).then(({ data }) => {
			if (!data.success) {
				console.error(data.error);
				return;
			}

			// Vue.set(Spark.state, 'currentTeam', data.team);

			commit("SET_VALUE", {
				name: `currentTeam`,
				value: data.team
			});

			return data;
		});
	},

	setTeamSettingValue({ commit, rootState }, payload) {
		return axios.post("/api/team/settings", payload).then(({ data }) => {
			if (!data.success) {
				console.error(data.error);
				return;
			}

			_.forIn(data.settings, (value, name) => {
				if (name === "theme") {
					data.themeRefresh = !isEquivalent(rootState.theme, value);
				}

				commit("SET_VALUE", {
					name: `currentTeam.team_settings.${name}`,
					value
				});
			});

			return data;
		});
	},

	setUserSettingValue({ commit }, payload) {
		commit("SET_VALUE", payload);
		axios.post("/api/user/settings", payload);
	},

	getUserSettings({ commit }, payload) {
		axios.get("/api/user/settings").then(({ data }) => {
			_.forIn(data, (value, name) => {
				commit("SET_VALUE", {
					name,
					value
				});
			});
		});
	},

	getUser({ commit, state, getters }, payload) {
		return axios.get(`/api/user/${payload}`).then(({ data: user }) => {
			const currentUsers = getObjectValue("admin.users", state, []);

			const usersMap = {};
			currentUsers.forEach(user => (usersMap[user.id] = user));
			usersMap[user.id] = user;
			users = Object.values(usersMap);

			commit("SET_VALUE", { name: "admin.users", value: users });

			return user;
		});
	},

	getUsers({ commit, state, getters }, { replace = false, ...payload }) {
		if (payload.admin && getters.searchQuery) {
			payload.search = getters.searchQuery;
		}

		return axios.get("/api/users", { params: payload }).then(({ data }) => {
			let { data: users } = data;

			if (getObjectValue("admin", payload, false)) {
				commit("SET_VALUE", {
					name: "admin.users_page",
					value: data.current_page
				});

				commit("SET_VALUE", {
					name: "admin.users_last_page",
					value: data.last_page
				});

				const currentUsers = getObjectValue("admin.users", state, []);

				if (!replace) {
					const usersMap = {};
					currentUsers.forEach(user => (usersMap[user.id] = user));
					users.forEach(user => (usersMap[user.id] = user));
					users = Object.values(usersMap);
				}

				commit("SET_VALUE", { name: "admin.users", value: users });
			} else {
				commit("SET_VALUE", { name: "users", value: users });
			}
		});
	},

	ajaxRequest({ commit, state }, payload) {
		let requestString =
			getObjectValue("method", payload, "get") +
			"-" +
			payload.url +
			paramString(getObjectValue("params", payload, {}));

		let request = getObjectValue(`requests.${requestString}`, state, false);

		if (!request) {
			commit("ADD_REQUEST", {
				name: requestString,
				request: axios.request(payload)
			});
		}

		return state.requests[requestString]
			.then(data => {
				commit("REMOVE_REQUEST", requestString);
				return data;
			})
			.catch(errors => {
				commit("REMOVE_REQUEST", requestString);
				return errors;
			});
	}
};
